export default __webpack_public_path__ + "static/HomepageHeroBackground-21b94d07b7bd1bae164dd06d1da11878.jpg";